import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { blogService, BlogPost } from "../services/firebase";
import "./BlogDetail.css";
import CurvedAccent from "assets/icone/CurvedAccent";
import BlogCard from "components/BlogCard";

const BlogList: React.FC = () => {
  const { t } = useTranslation();
  const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [screenSize, setScreenSize] = useState<"desktop" | "tablet" | "mobile">(
    "desktop"
  );
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setScreenSize("mobile");
      } else if (window.innerWidth <= 768) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const data = await blogService.getAll();
        setBlogPosts(data);
      } catch (error) {
              } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  if (loading) {
    return (
      <div className="page-container">
        <h1 className="page-title">{t("blog")}</h1>
        <div style={{ textAlign: "center", padding: "2rem" }}>
          {t("loading")}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="blog-list-container">
        <div className="blog-list-header">
          <h1 className="blog-list-main-title">{t("blog")}</h1>
          <h2 className="blog-list-header-subtitle">{t("blogSubtitle")}</h2>
          <p className="blog-list-header-description">
            {t("blogDescriptionPart1")}
            {screenSize !== "mobile" && <br />}
            {screenSize === "mobile" && " "}

            {t("blogDescriptionPart2")}
          </p>
        </div>

        <div className="blog-list-grid" ref={ref}>
          {blogPosts
            .sort((a, b) => {
              const dateA = a.publishedAt || a.createdAt;
              const dateB = b.publishedAt || b.createdAt;
              if (!dateA || !dateB) return 0;
              const timestampA = dateA.toDate
                ? dateA.toDate().getTime()
                : new Date(dateA).getTime();
              const timestampB = dateB.toDate
                ? dateB.toDate().getTime()
                : new Date(dateB).getTime();
              return timestampB - timestampA; // חדש ביותר קודם
            })
            .map((post) => (
              <BlogCard key={post.id} post={post} inView={inView} />
            ))}
        </div>
      </div>
    </>
  );
};

export default BlogList;
